import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import Modal from 'react-modal';
import dt from "core/dialog-translations";
import { Button } from '@getgo/chameleon-web-react-wrapper';
import ResponsiveDialog from 'components/dialog-view.js';
if (process.env.NODE_ENV !== 'test') {
  Modal.setAppElement('#root');
}

const ConfirmDialogView = ({
  textResourceId,
  closeConfirmModalYesFn,
  closeConfirmModalNoFn,
  closeModal,
  modalIsOpen,
  dynamicVal,
  variant = "primary"
}) => {
  const intl = useIntl();
  return (
    <ResponsiveDialog
      open={modalIsOpen}
      title={<FormattedMessage {...dt[`confirmDialog.${textResourceId}.title`]} />}
      onClosed={closeModal}
      closable={textResourceId === 'deleteClient' || textResourceId === 'deleteSecretKey'}
      actions={
        <React.Fragment>
          <Button
            data-testid="yesBtn"
            variant={textResourceId === 'deleteClient' || textResourceId === 'deleteSecretKey' ? "danger":variant}
            onClick={closeConfirmModalYesFn}>
            <FormattedMessage {...dt[`confirmDialog.${textResourceId}.yesButtonText`]} />
          </Button>
          <Button data-testid="noBtn" variant="tertiary" onClick={closeConfirmModalNoFn}>
            <FormattedMessage {...dt[`confirmDialog.${textResourceId}.noButtonText`]} />
          </Button>
        </React.Fragment>
}>
      <FormattedMessage {...dt[`confirmDialog.${textResourceId}.text`]} values={{dynamicVal: <b>{dynamicVal}</b>}} />
    </ResponsiveDialog>
  );
};

ConfirmDialogView.propTypes = {
  textResourceId: PropTypes.string.isRequired,
  closeConfirmModalYesFn: PropTypes.func.isRequired,
  closeConfirmModalNoFn: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  dynamicVal: PropTypes.string,
  variant: PropTypes.string
};

export default ConfirmDialogView;
